import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from 'office-ui-fabric-react';
import clsx from 'clsx';
import styles from './Main.style';

/**
 * Main should wrap the pages **content**. It's named after the html <main> tag.
 * Helps set your Grid up for success. It is only meant to be used ONCE, just like <main>.
 *
 * Reference: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/main
 */
const Main = ({ children, className: classNameProp, fullWidth, ...other }) => {
  const className = clsx(styles.root, classNameProp, fullWidth && styles.fullWidth);

  return (
    <Stack className={className} {...other}>
      {children}
    </Stack>
  );
};

Main.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

Main.defaultProps = {
  className: '',
  fullWidth: false,
};

export default Main;
